module.exports = __webpack_public_path__ + "img/con_dry.d454fe86.png";